var _path, _path2, _g, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconFail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: 92
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "background",
    d: "M11 22C17.0751 22 22 17.0751 22 11C22 4.92487 17.0751 0 11 0C4.92487 0 0 4.92487 0 11C0 17.0751 4.92487 22 11 22Z",
    fill: "#FD4760"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1231_15931",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 22,
    height: 22
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "background_2",
    d: "M11 22C17.0751 22 22 17.0751 22 11C22 4.92487 17.0751 0 11 0C4.92487 0 0 4.92487 0 11C0 17.0751 4.92487 22 11 22Z",
    fill: "#FD4760"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1231_15931)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 1",
    d: "M13 22L6.5 16.5L9.5 8L12.5 6.5L22 12.5C21.8172 19.746 16.0797 21.2632 13 22Z",
    fill: "#AF0000"
  })))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.7463 13.4893L12.6384 6.56577C11.9007 5.32183 10.0994 5.32183 9.36165 6.56577L5.25384 13.4893C4.5006 14.7595 5.41583 16.3682 6.89267 16.3682H15.1074C16.586 16.3665 17.4995 14.7595 16.7463 13.4893ZM11 14.8347C10.8258 14.8347 10.6555 14.783 10.5107 14.6862C10.3658 14.5894 10.2529 14.4519 10.1862 14.2909C10.1196 14.13 10.1021 13.9528 10.1361 13.782C10.1701 13.6111 10.254 13.4541 10.3772 13.331C10.5004 13.2078 10.6573 13.1239 10.8282 13.0899C10.9991 13.0559 11.1762 13.0733 11.3371 13.14C11.4981 13.2067 11.6357 13.3196 11.7325 13.4644C11.8292 13.6093 11.8809 13.7796 11.8809 13.9538C11.8809 14.0695 11.8581 14.184 11.8139 14.2909C11.7696 14.3978 11.7047 14.4949 11.6229 14.5767C11.5411 14.6585 11.444 14.7234 11.3371 14.7676C11.2303 14.8119 11.1157 14.8347 11 14.8347ZM11.905 9.2264L11.7963 11.7732C11.7867 11.9779 11.6987 12.1712 11.5504 12.3127C11.4021 12.4542 11.205 12.5332 11 12.5332C10.7951 12.5332 10.5979 12.4542 10.4497 12.3127C10.3014 12.1712 10.2134 11.9779 10.2038 11.7732L10.0951 9.2264C10.0898 9.10424 10.1093 8.98227 10.1523 8.86784C10.1954 8.75341 10.2612 8.64889 10.3458 8.56057C10.4303 8.47225 10.5319 8.40196 10.6443 8.35394C10.7568 8.30592 10.8778 8.28117 11 8.28117C11.1223 8.28117 11.2433 8.30592 11.3558 8.35394C11.4682 8.40196 11.5698 8.47225 11.6543 8.56057C11.7389 8.64889 11.8047 8.75341 11.8478 8.86784C11.8908 8.98227 11.9103 9.10424 11.905 9.2264Z",
    fill: "white"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFail);
export default __webpack_public_path__ + "static/media/icon_fail.bbb6071f3ea00858ac110633ff2a0f8b.svg";
export { ForwardRef as ReactComponent };